import React from 'react';
import ReactDOM from 'react-dom';
import MainApp from './mainApp';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './App.css'
import { createRoot } from 'react-dom/client';
import { messaging, messagingPromise} from './firebase-config';
import { NotificationProvider } from './context/NotificationContext';
import { setupServiceWorkerMessageListener } from './utils/serviceWorkerUtils';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
      .register('/firebase-messaging-sw.js')  // This should match the location in the public folder
      .then(function (registration) {
          console.log('Service Worker registered:', registration);
          messagingPromise.useServiceWorker(registration);  // Use the service worker for Firebase messaging
      })
      .catch(function (error) {
          console.log('Service Worker registration failed:', error);  // This will log any registration errors
      });
}

// Setup service worker message listener once
setupServiceWorkerMessageListener();

const root = document.getElementById('root');
const rootContainer = createRoot(root);
rootContainer.render(
  <React.StrictMode>
    <BrowserRouter>
    <NotificationProvider>

      <MainApp />

      </NotificationProvider>

    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
